import { BoloSearchForm } from '@mark43/cad-api';
import { createContext, ReactNode, useContext } from 'react';
import { TabsContextType, useSearchTabs } from '../../search-windows/use-search-tabs';

const BoloSearchTabsContext = createContext<TabsContextType<BoloSearchForm> | undefined>(undefined);

export function useBoloSearchTabsContext() {
    const context = useContext(BoloSearchTabsContext);
    if (context === undefined) {
        throw new Error('useBoloSearchTabsContext must be used within an BoloSearchTabsProvider');
    }
    return context;
}

export const BoloSearchTabsProvider = ({
    initialTab,
    children,
}: {
    initialTab: string;
    children: ReactNode;
}) => {
    const tabsValue = useSearchTabs<BoloSearchForm>(initialTab);
    return (
        <BoloSearchTabsContext.Provider value={tabsValue}>
            {children}
        </BoloSearchTabsContext.Provider>
    );
};
